@if ((breadcrumb() ?? []).length > 0) {
  <div
    class="relative z-10 mb-2 border-b border-foreground/6 bg-background/80 backdrop-blur supports-backdrop-filter:bg-background/60"
  >
    <nav
      [attr.aria-label]="'common.breadcrumbAriaLabel' | transloco"
      class="container mx-auto px-4 py-4 md:px-6"
    >
      <ol class="flex max-w-full flex-wrap items-center gap-x-2 gap-y-1 text-[13px] text-muted-foreground">
        <li class="shrink-0">
          <a
            [routerLink]="'/' | localizedRouterLink"
            [attr.aria-label]="'common.home' | transloco"
            class="inline-flex h-7 w-7 items-center justify-center rounded-full text-muted-foreground transition hover:bg-foreground/4 hover:text-primary"
          >
            <svg
              aria-hidden="true"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="h-3.5 w-3.5"
            >
              <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
              <path d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            </svg>
          </a>
        </li>

        @for (item of breadcrumb() ?? []; track item.label ?? item.labelKey ?? $index; let last = $last) {
          <li class="flex min-w-0 max-w-full items-center gap-2" [class.shrink-0]="!last">
            <span aria-hidden="true" class="shrink-0 select-none text-foreground/20">/</span>
            @if (item.path && !last) {
              <a
                [routerLink]="item.path | localizedRouterLink"
                class="rounded px-1 py-0.5 transition hover:text-primary"
              >
                @if (item.label) {
                  {{ item.label }}
                } @else if (item.labelKey) {
                  {{ item.labelKey | transloco }}
                }
              </a>
            } @else {
              <span
                class="min-w-0 break-words rounded px-1 py-0.5"
                [class.font-medium]="last"
                [class.text-foreground]="last"
                [attr.aria-current]="last ? 'page' : null"
              >
                @if (item.label) {
                  {{ item.label }}
                } @else if (item.labelKey) {
                  {{ item.labelKey | transloco }}
                }
              </span>
            }
          </li>
        }
      </ol>
    </nav>
  </div>
}

<section
  class="container mx-auto px-4 pb-20 md:px-6"
  [class.max-w-6xl]="width() === 'narrow'"
  [class.max-w-7xl]="width() === 'wide'"
>
  <ng-content />
</section>
